import { Box, Flex, Image } from '@chakra-ui/react'
import Amplify from 'aws-amplify'
import React, { useEffect, useState } from 'react'
import 'react-phone-input-2/lib/style.css'
import { FORM_VIEW } from './otp.config'
import OTPNumberInput from '../otp-input'
import PhoneNumberInput from './phonenumber'
import greneLogo from '../../../assets/images/grene-logo.png'
import { VIEW_MODE } from './../login.util'

export function OTPLogin({ setLoginViewMode }) {
  const [view, setView] = useState(FORM_VIEW.PHONE_VIEW)
  const [user, setuser] = useState(null)
  const [phoneDetail, setPhoneDetail] = useState(null)

  useEffect(() => {
    Amplify.configure({
      Auth: {
        mandatorySignIn: true,
        userPoolId: process.env.REACT_APP_OTP_USER_POOL_ID,
        identityPoolId: process.env.REACT_APP_OTP_IDENTITY_POOL_ID,
        userPoolWebClientId: process.env.REACT_APP_OTP_WEB_NO_SECRETE_CLIENT_ID,
        region: process.env.REACT_APP_OTP_AWS_REGION,
      },
      Analytics: {
        disabled: true,
      },
    })
  }, [])

  const onValidationSuccess = () => {
    setLoginViewMode(VIEW_MODE.ORG)
  }

  return (
    <Box
      bg="white"
      boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)"
      borderRadius="20px"
      minW="28rem"
      padding="3em 0em"
      color="black"
    >
      <Flex
        flex={1}
        h="full"
        alignItems="center"
        justifyContent="center"
        flexDir="column"
        gap="1rem"
      >
        <Image src={greneLogo} maxW="64px" />
        {view === FORM_VIEW.PHONE_VIEW ? (
          <PhoneNumberInput
            onSendOtpSuccess={(user, view, data) => {
              setView(view)
              setuser(user)
              setPhoneDetail(data)
            }}
            setLoginMode={setLoginViewMode}
          />
        ) : view === FORM_VIEW.OTP_VIEW ? (
          <>
            <OTPNumberInput
              user={user}
              setView={setView}
              phoneDetail={phoneDetail}
              onValidationSuccess={onValidationSuccess}
            />
          </>
        ) : null}
      </Flex>
    </Box>
  )
}
